export default __webpack_public_path__ + "static/media/637.59cf49ef.png";